// Episode history distinguishes a "zombie" (stream died while the network stayed up) from the transient
// offline->recovery window (DNS back, first frame not yet). They share the same flags
// (isConnected true, isSubscriptionBroken true), so we track whether the network actually dropped this
// episode: only then is "appConnected true" a real recovery that should dismiss the modal.

// An episode is a contiguous period that isn't fully healthy. Full health resets it; a real drop marks
// it; a zombie (online but broken) leaves it unchanged.
export const nextDroppedThisEpisode = (prev: boolean, isConnected: boolean, isSubscriptionBroken: boolean): boolean => {
	if (isConnected && !isSubscriptionBroken) {
		return false;
	}
	if (!isConnected) {
		return true;
	}
	return prev;
};

export const computeIsZombie = (
	isConnected: boolean,
	isSubscriptionBroken: boolean,
	droppedThisEpisode: boolean,
): boolean => isConnected && isSubscriptionBroken && !droppedThisEpisode;
